import React from "react";
import { Container } from "react-bootstrap";

const PitchBS = () => {
  return (
    <>
      <section className="py-5">
        <Container>
          <p className="section-subtitle  text-start mb-2 px-3 pb-3">
            Balance Sheet
          </p>
          {/* first table */}
          <div className="scroll-x">
            <table className="custom-table">
              <thead>
                <tr>
                  <th>Description</th>
                  <th>Year 01</th>
                  <th>Year 02</th>
                  <th>Year 03</th>
                  <th>Year 04</th>
                  <th>Year 05</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Cash</td>
                  <td> $7,660,800,000</td>
                  <td> $32,166,311,826</td>
                  <td> $73,427,130,159</td>
                  <td> $137,505,771,879</td>
                  <td> $244,768,038,879</td>
                </tr>
                <tr>
                  <td>Accounts Receivable</td>
                  <td> </td>
                  <td> </td>
                  <td> </td>
                  <td> </td>
                  <td> </td>
                </tr>
                <tr>
                  <td>Inventory</td>
                  <td> </td>
                  <td> </td>
                  <td> </td>
                  <td> </td>
                  <td> </td>
                </tr>
                <tr>
                  <td>Other Current Assets</td>
                  <td> </td>
                  <td> </td>
                  <td> </td>
                  <td> </td>
                  <td> </td>
                </tr>
                <tr className="lead-row">
                  <td>Total Current Assets</td>
                  <td> $7,660,800,000</td>
                  <td> $32,166,311,826</td>
                  <td> $73,427,130,159</td>
                  <td> $137,505,771,879</td>
                  <td> $244,768,038,879</td>
                </tr>
                <tr>
                  <td>Long Term Assets</td>
                  <td> $84,000,000</td>
                  <td> $300,000,000</td>
                  <td> $588,000,000</td>
                  <td> $876,000,000</td>
                  <td> $1,212,000,000</td>
                </tr>
                <tr>
                  <td>Accumulated Depreciation</td>
                  <td> $2,520,000</td>
                  <td> $11,520,000</td>
                  <td> $29,160,000</td>
                  <td> $55,440,000</td>
                  <td> $91,800,000</td>
                </tr>
                <tr>
                  <td className="lead-cell">Total Long Term Assets</td>
                  <td> $81,480,000</td>
                  <td> $288,480,000</td>
                  <td> $558,840,000</td>
                  <td> $820,560,000</td>
                  <td> $1,120,200,000</td>
                </tr>
                <tr className="lead-row">
                  <td className="lead-cell">Total Assets</td>
                  <td> $7,742,280,000</td>
                  <td> $32,454,791,826</td>
                  <td> $73,985,970,159</td>
                  <td> $138,326,331,879</td>
                  <td> $245,888,238,879</td>
                </tr>
                <tr>
                  <td colSpan={6}>Accounts Payable</td>
                </tr>
                <tr>
                  <td colSpan={6}>Income Tax Payable</td>
                </tr>
                <tr>
                  <td colSpan={6}>Sales Tax Payable</td>
                </tr>
                <tr>
                  <td colSpan={6}>Short Term Debt</td>
                </tr>
                <tr>
                  <td colSpan={6}>Prepaid Revenue</td>
                </tr>

                <tr className="lead-row">
                  <td>Total Current Liabilities</td>
                  <td>$</td>
                  <td>$</td>
                  <td>$</td>
                  <td>$</td>
                  <td>$</td>
                </tr>
                <tr>
                  <td>Long Term Debt</td>
                  <td>$</td>
                  <td>$</td>
                  <td>$</td>
                  <td>$</td>
                  <td>$</td>
                </tr>

                <tr className="lead-row">
                  <td>Total Liabilities</td>
                  <td>$</td>
                  <td>$</td>
                  <td>$</td>
                  <td>$</td>
                  <td>$</td>
                </tr>
                <tr className="light-bg">
                  <td></td>
                </tr>
                <tr>
                  <td>Paid-in Capital</td>
                  <td> $5,190,005,961</td>
                  <td> $14,492,086,212</td>
                  <td> $18,286,910,025</td>
                  <td> $18,286,910,025</td>
                  <td> $18,286,910,025</td>
                </tr>
                <tr>
                  <td>Retained Earnings</td>
                  <td> $-</td>
                  <td> $2,552,274,039</td>
                  <td> $17,962,705,614</td>
                  <td> $55,699,060,134</td>
                  <td> $120,039,421,854</td>
                </tr>
                <tr>
                  <td>Earnings</td>
                  <td> $2,552,274,039</td>
                  <td> $15,410,431,575</td>
                  <td> $37,736,354,520</td>
                  <td> $64,340,361,720</td>
                  <td> $107,561,907,000</td>
                </tr>
                <tr>
                  <td>Owner's Equity</td>
                  <td> $7,742,280,000</td>
                  <td> $32,454,791,826</td>
                  <td> $73,985,970,159</td>
                  <td> $138,326,331,879</td>
                  <td> $245,888,238,879</td>
                </tr>
                <tr>
                  <td>Total Liabilities & Equity</td>
                  <td> $7,742,280,000</td>
                  <td> $32,454,791,826</td>
                  <td> $73,985,970,159</td>
                  <td> $138,326,331,879</td>
                  <td> $245,888,238,879</td>
                </tr>
                {/* <tr>
                <td>Change in Long-T..</td>
                <td>$</td>
                <td>$</td>
                <td>$</td>
                <td>$</td>
                <td>$</td>
              </tr>
              <tr>
                <td>Retained Earnings</td>
                <td>$</td>
                <td> $2,552,274,039</td>
                <td> $17,962,705,614</td>
                <td> $55,699,060,134</td>
                <td> $120,039,421,854</td>
              </tr>
              <tr>
                <td>Earnings</td>
                <td> $2,552,274,039</td>
                <td> $15,410,431,575</td>
                <td> $37,736,354,520</td>
                <td> $64,340,361,720</td>
                <td> $107,561,907,000</td>
              </tr>
              <tr>
                <td>Cash at Beginnin..</td>
                <td>$</td>
                <td>$64,350,000,000</td>
                <td>$</td>
                <td>$64,350,000,000</td>
                <td>$</td>
              </tr>
              <tr className="lead-row">
                <td>Total Owner's Eq..</td>
                <td> $7,742,280,000</td>
                <td> $32,454,791,826</td>
                <td> $73,985,970,159</td>
                <td> $138,326,331,879</td>
                <td> $245,888,238,879</td>
              </tr>
              <tr className="lead-row">
                <td>Total Liabilities &..</td>
                <td> $7,742,280,000</td>
                <td> $32,454,791,826</td>
                <td> $73,985,970,159</td>
                <td> $245,888,238,879</td>
                <td> $245,888,238,879</td>
              </tr> */}
              </tbody>
            </table>
          </div>
        </Container>
      </section>
    </>
  );
};

export default PitchBS;
